// extracted by mini-css-extract-plugin
export default {"chapterContainerLeft":"chapter_chapterContainerLeft__hBmYS","chapterContainerRight":"chapter_chapterContainerRight__RBI63","textContainer":"chapter_textContainer__xR4Vd"};